import { Component, OnInit, Input, ViewChild, NgZone } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { Instruction } from '../../../../models/Instruction';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { User } from 'src/app/models/User';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { ScanQrWebComponent } from '../../scan-qr-web/scan-qr-web.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Component({
  selector: 'app-command',
  templateUrl: './command.component.html',
  styleUrls: ['./command.component.scss']
})
export class CommandComponent implements OnInit {

  public status: number = 1;
  public title: string;
  public subtitle: string[] = [];
  public commandName: string;
  public titleStatus1: string;
  public subtitleStatus1: string[] = [];
  public titleStatus2: string;
  public titleStatus3: string;
  public subtitleStatus3: string[] = [];
  public loadingText: string;
  @Input('userName') userName: string;
  @Input('user') user: User;
  @Input('s_ins') s_ins: number;
  private setIntID: any;
  private remctrlNum = '';
  public seconds = 35;
  private isServiceBusy = false;

  constructor(private modalCtrl: ModalController,
    private profileInstallationService: ProfileInstallationService,
    public gvs: GlobalVariablesService,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
    private barcodeScanner: BarcodeScanner,
    private platform: Platform,
    private zone: NgZone,
    private translate: TranslateConfigService) { }

  async ngOnInit() {
    this.gms.loading();
    await this.loadTexts();
    if (this.user.remctrl_num !== '') {
      this.title = this.titleStatus3;
      this.subtitle = this.subtitleStatus3;
      this.status = 3;
    } else {
      this.title = this.titleStatus1;
      this.subtitle = this.subtitleStatus1;
    }
    this.modalCtrl.dismiss(false, '', 'loadSpinner');
  }

  ionViewWillEnter() {
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Escaner QR Mando', contentGroup: 'Configurar Mando'}); 
  }

  async dismiss(confirm: boolean, modalID: string, result?: boolean, user?: User) {
    await this.modalCtrl.dismiss({ confirm: confirm, result: result, user: user }, '', modalID);
  }

  async loadTexts() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let instructions: Instruction[] = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 40, 'SIC0200_0100', 'users');
      this.titleStatus1 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';

      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 41, 'SIC0200_0100', 'users');
      if (instructions.length > 0 && instructions[0].texts != null ){
        this.subtitleStatus1.push(instructions[0].texts);
        this.subtitleStatus1 = this.subtitleStatus1[0].split('\r\n');
      }
      
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 42, 'SIC0200_0100', 'users');
      this.titleStatus2 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';

      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 43, 'SIC0200_0100', 'users');
      this.titleStatus3 = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';

      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 44, 'SIC0200_0100', 'users');
      this.subtitleStatus3[0] = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : undefined;
      if (instructions.length > 0 && instructions[0].texts != null){
        this.subtitleStatus3.push(instructions[0].texts);
      }
      instructions = await this.profileInstallationService.gAppuserText(this.userName, this.gvs.lang, 84, 'SIC0200_0100', 'users');
      this.loadingText = instructions.length > 0 && instructions[0].texts != null ? instructions[0].texts : '';
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async saveConf() {
    await this.dismiss(true, 'commandModal', true, this.user);
  }

  async deleteCommand() {
    if (this.isServiceBusy) {
      return;
    }
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.isServiceBusy = true;
      await this.gms.loading();
      let newUser: User = JSON.parse(JSON.stringify(this.user));
      newUser.remctrl_ind = '';
      newUser.remctrl_num = '';
      const response = await this.profileInstallationService.cAppuserUserUpd(this.s_ins, newUser, 5, 'commandComponent', this.userName);
      if (response === undefined) {
        return;
      }
      if (response) {
        await this.dismiss(true, 'commandModal', true, newUser);
      } else {
        await this.dismiss(true, 'commandModal', false, newUser);
      }
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      this.isServiceBusy = false;
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async scanQR() {
    if (await this.platform.is('cordova')) {
      this.barcodeScanner.scan().then(async barcodeData => {
        if (barcodeData.text != null && barcodeData.text !== '') {
          await this.sendQr(barcodeData.text);
        }
      }).catch(async err => {
        const message = JSON.stringify(err);
        await FirebaseCrashlytics.recordException({ message: message });
      });
    } else {
      this.openScanQrWeb();
    }
  }

  async openScanQrWeb() {
    const contentModal = await this.modalCtrl.create({
      component: ScanQrWebComponent,
      componentProps: {},
      cssClass: ['w-modal-md'],
    });
    contentModal.onDidDismiss().then(response => {
      this.zone.run(async () => {
        if (response.data != null && response.data.confirm && response.data.qr != null) {
          const qr = response.data.qr;
          await this.sendQr(qr);
        }
      });
    });

    await contentModal.present();
  }

  async sendQr(qr: string) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      const response = await this.profileInstallationService.cAppuserUserQr(this.user.email, this.s_ins,
        this.user.s_cont, this.user.cix, qr, 5, 'commandComponent');
      if (response === undefined) {
        return;
      }
      if (response) {
        await this.checkConfDevice();
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.sendQRKo'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async checkConfDevice() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      await this.gms.loading(this.loadingText);
      this.setIntID = setInterval(async () => {
        if (this.remctrlNum === '') {
          if (this.seconds > 0) {
            this.remctrlNum = await this.profileInstallationService.gAppuserDeviceConfigured(this.user.email, this.s_ins, this.user.s_cont,
              this.user.cix, 5, 'commandComponent');
            if (this.remctrlNum === undefined) {
              clearInterval(this.setIntID);
              this.modalCtrl.dismiss(false, '', 'loadSpinner');
              return;
            }
            this.seconds -= 2;
          } else {
            clearInterval(this.setIntID);
            this.seconds = 35;
            this.modalCtrl.dismiss(false, '', 'loadSpinner');
            this.gms.analyticsTrackEvent('event_remote_control', {eventCategory: 'SICOR/Control Remoto', eventAction: 'Error/Configuracion OK'});
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.confDeviceKo'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }

        } else {
          clearInterval(this.setIntID);
          this.seconds = 35;
          let tempUser: User = JSON.parse(JSON.stringify(this.user));
          tempUser.remctrl_ind = 'X';
          tempUser.remctrl_num = this.remctrlNum;
          const newUser = await this.updateConfDevice(tempUser);
          if (newUser === undefined) {
            return;
          }
          if (newUser != null) {
            this.title = this.titleStatus2;
            this.subtitle = undefined;
            this.status = 2;
            this.user = newUser;
          }
          this.gms.analyticsTrackEvent('event_remote_control', {eventCategory: 'SICOR/Control Remoto', eventAction: 'Accion/Configuracion OK'});
          this.modalCtrl.dismiss(false, '', 'loadSpinner');
        }
      }, 2000);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async updateConfDevice(user: User) {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      return await this.profileInstallationService.cAppuserUserUpd(this.s_ins, user, 5, 'commandComponent', this.userName);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async modifyCommand() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      await this.gms.loading();
      let newUser: User = JSON.parse(JSON.stringify(this.user));
      newUser.remctrl_ind = 'X';
      newUser.remctrl_num = '';
      const response = await this.profileInstallationService.cAppuserUserUpd(this.s_ins, newUser, 5, 'commandComponent', this.userName);
      if (response === undefined) {
        return;
      }
      if (response) {
        this.user = newUser;
        await this.scanQR();
      }
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }
}
